import axiosapi from "../api/axiosapi";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import useAuth from "../hooks/useAuth";

const GradeTotalListTextbook = () => {
    const [textbookList, setTextbookList] = useState([]);
    const [sampleTextbookList, setSampleTextbookList] = useState([]);
    const [randomString, setRandomString] = useState();
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchTextbookList = async () => {
            try {
                const response = await axiosapi.get('/phase/textbook/list')
                response.data && setTextbookList(response.data);
            } catch(err) {
                console.log(err)
            }
        }

        const fetchSampleTextbookList = async () => {
            try {
                const response2 = await axiosapi.get('/sample/subject/textbook/')
                response2.data && setSampleTextbookList(response2.data);
            } catch(err) {
                console.log(err)
            }
        }

        fetchTextbookList();
        fetchSampleTextbookList();
    },[])

    return(
        <div className="vertical-flex-container-1">
            <div className="content-box-1">
                <div className="card-list-title">
                    <h4 style={{color:"sienna", fontWeight:"bold"}}>그리며 공부하기 샘플</h4>
                </div>
                <div className="card-container">
                    {/* <div className="containerListItem">
                        <div className="improveAbilityCards"> */}
                            {sampleTextbookList && sampleTextbookList.map( subject => {
                                return(
                                    <div key={subject.id} className="card">
                                        <h5>{subject.sampleSubjectTitle}</h5>
                                        <p>{subject.sampleSubjectDescription}</p>
                                        <Link 
                                            to={`/mathsubject/sample/${subject.urlCode}` }
                                            state={{
                                                "subjectCode": subject.subjectCode,
                                                "problemCode": subject.firstProblemCode,
                                                "subjectTitle": subject.sampleSubjectTitle
                                            }}
                                        >
                                            바로가기
                                        </Link>
                                    </div>
                                )
                            })}
                        {/* </div>
                    </div> */}
                </div>
            </div>
            <div className="content-box-1">
                {textbookList && textbookList.map(grade => {
                    return(
                        <div key={grade.phaseCode}>
                            <div className="card-list-title">
                                <h4 style={{color:"sienna", fontWeight:"bold"}}>{grade.phaseTitle}</h4>
                            </div>
                            <div className="card-container">
                                {/* <div className="containerListItem">
                                    <div className="improveAbilityCards"> */}
                                        {grade.subjects && grade.subjects.map( subject => {
                                            return(
                                                <div key={subject.subjectCode} className="card">
                                                    <h5>{subject.subjectTitle}</h5>
                                                    <p>{subject.subjectDescription}</p>
                                                    <Link 
                                                        to={`/mathsubject/${randomString}` }
                                                        state={{
                                                            "subjectCode": subject.subjectCode,
                                                            "problemCode": subject.firstProblemCode,
                                                            "subjectTitle": subject.subjectTitle
                                                        }}
                                                    >
                                                        바로가기
                                                    </Link>
                                                </div>
                                            )
                                        })}
                                    {/* </div>
                                </div> */}
                            </div>
                        </div>
                    )
                })}
            </div>
            <div style={{width: "100%"}}>
                <Footer/>
            </div>
        </div>
    )
}

export default GradeTotalListTextbook;